import React, { useEffect, useMemo, useState } from "react";
import {
  BackButton,
  CancelButton,
  SubmitButton,
} from "../../../../Components/Utils/Buttons";
import FormikSelectTwo, {
  SelectProductWithError,
  TwoNEW,
} from "../../../../Components/Utils/Select";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import { useFormik } from "formik";
import * as yup from "yup";
import {
  NuDate,
  NuInput,
  NuTextArea,
} from "../../../../Components/Utils/Input";
import Delete from "../../../../Components/Icons/Delete";
import UseDropDown from "../../../../Components/Hooks/useDropDown";
import { TextMediumBase } from "../../../../Components/Text/MediumText";
import axiosInstance from "../../../../Services/axiosCommon";
import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";
import DropDownAddMetaData from "../../../../Components/Utils/selectAddMetaData";
import Select from "react-select";
import EditIcon from "../../../../Components/Icons/Edit";
import DropDownAddCurrency from "../../../../Components/Utils/selectAddCurrencyDropDown";
import UseFetchCurrency from "../../../../Components/Hooks/useFetchCurrencyData";
import NuAmount from "../../../../Components/Utils/NuAmount";
import { useToast } from "../../../../Components/Others/ToastServices";
import DropDownAddSubCategory from "../../../../Components/Utils/selectAddSubCategory";
import DropDownAdd from "../../../../Components/Utils/selectAdd";
import UseCatSubCatDropDown from "../../../../Components/Hooks/useCategoryDropDown";
import Attachement from "../../../../Components/Utils/CustomAttrachmentupload";
import useAddFormData from "../../../../Components/Hooks/useAddFormData";
import { formatDisplaySno, formatDisplaySno2 } from "../../../../Components/Utils/formatDisplaySno";
import { useLocation } from "react-router-dom";
import { useCurrency } from "../../../../Context/CurrencyContext";
import UseProductDropDownNew from "../../../../Components/Hooks/useProductSearch";
import UseSupplierDropDownNew from "../../../../Components/Hooks/useSupplierSearch";
const filetype = [
  "docx",
  "doc",
  "xlsx",
  "xls",
  "pdf",
  "txt",
  "pptx",
  "mp4",
  "mov",
  "wmv",
  "avi",
  "flv",
  "mkv",
];

function RfqCreateSupplierQuotes() {
  const toast = useToast();
  const { currencySymbol } = useCurrency();
  const location = useLocation();
  const data = location.state.data;
  console.log("suqu", data?.id);
  const { value: Validity, getData: refValidity } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "Validity_Supplierquotes",
  );
  const { value: PaymentTerms, getData: refPaymentTerms } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "PaymentTerms_Supplierqoutes",
  );
  const { value: leadTime, getData: refLeadTime } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "LeadTime_Supplierqoutes",
  );
  const { value: DeliveryTerms, getData: refDeliveryTerms } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "DeliveryTerms_Supplierqoutes",
  );
  const { value: Availability, getData: refAvailability } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "Availability_Supplierqoutes",
  );
  const { value: paymentMethod, getData: refpaymentMethod } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "paymentMethod_supplierquotes",
  );
  const [isEditing, setIsEditing] = useState(false);

  const { value: brand } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "brand_item",
  );
  const { value: Manufacture } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "Manufacture_item",
  );

  const toggleEdit = () => {
    setIsEditing(!isEditing);
  };
  const [sortedProList, setSortedProList] = useState([]);
  const [oldData, setOldData] = useState([]);
  const [search, setSearch] = useState("");
  const { data: Item, setData } = UseProductDropDownNew(
    "/items/new-drop-down",
    search,
  );
  const [searchSupplier, setSearchSupplier] = useState("");

  const { data: vendors, setDataSupplier } = UseSupplierDropDownNew(
    "/vendors/drop-down",
    searchSupplier,
  );
  let { value: currency, getData: refCurrency } = UseFetchCurrency(
    "/currency/drop-down",
  );
  const { value: Unit, getData: refUnit } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "Unit_item",
  );

  const { data: PR } = UseDropDown("/PR/drop-down");
  const [rfqs, setRFQ] = useState([]);

  const { Oncancel, addFormData, contextHolder, isLoading } = useAddFormData();
  const [newItemData, setNewItemData] = useState({
    productId: "",
    quantity: "",
    price: "",
    landedCost: "",
    dutty: "",
    trans: "",
    sellingPrice: "",
  });
  const [createNew, setCreateNew] = useState({
    dateReceived: "",
    deliverTerms: "",
    paymentTerms: "",
    paymentMethod: "",
    totalPrice: 0.0,
    vendorId: data?.vendor || "",
    isDirectQuote: false,
    prId: data?.prId || "",
    rfqId: data?.id || "",
    ref: "",
    availability: "",
    validity: "",
    specialNotes: "",
    leadTime: "",
    preparedBy: "",
    reviewedBy: "",
    approvedBy: "",
    remarks: "",
    comments: "",
    products: "",
    productId: "",
    quoteDate: "",
    purchaserChecked: "",
    exchangeRate: "",
    lCost: "",
    others: "",
    boxTotal: 0.0,
    storeValue: 0.0,
  });

  const [error, setError] = useState("");

  useEffect(() => {
    // Set the initial quoteDate and quotationReceivedDate to the current date on component mount
    setCreateNew((prevCreateNew) => ({
      ...prevCreateNew,
      quoteDate: new Date().toISOString().slice(0, 10), // Format to YYYY-MM-DD
      dateReceived: new Date().toISOString().slice(0, 10),
    }));
  }, []);
  const [selectedFile, setSelectedFile] = useState(null);
  const [image, setImage] = useState([]);
  const [isDisabledd, setIsDisabledd] = useState(true);

  function handleImageChange(e) {
    const maxFileSize = 200000000; // 200 MB
    const files = Array.from(e.target.files);
    let fileArr = [];
    files.map((item) => {
      if (item.size < maxFileSize) {
        fileArr.push(item);
      } else {
        toast.open({
          type: "warning",
          message: `File Size to big`,
          description: `${item.name} is Removed and not Uploaded`,
        });
      }
    });
    let tempArr = [];
    setSelectedFile(fileArr);
    files.map((item) => {
      if (item.size < maxFileSize) {
        let fileName = item?.name;
        let fileExtention = fileName.split(".").reverse()[0];
        if (filetype?.includes(fileExtention)) {
          tempArr.push(fileName);
        } else {
          let x = URL.createObjectURL(item);
          tempArr.push(x);
        }
      }
    });
    console.log(tempArr, "temp");
    setImage(tempArr);
  }
  const handleChangeImg = (e) => {
    if (e.target.files.length) {
      setImage({
        preview: URL.createObjectURL(e.target.files[0]),
        raw: e.target.files[0],
      });
    }
  };
  const handleImageRemove = () => {
    setImage({
      preview: "",
      raw: "",
    });
  };
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      ref: yup.string().required("Quotation reference is required!"),
      vendorId: yup.string().required("Vendor is required!"),

      currencyId: yup.string().required("Please Choose Currency"),
    }),
    onSubmit: async (value, { resetForm }) => {
      let newItems = [];

      if (prlist.length > 0) {
        newItems = prlist.map((i) => ({ ...i, leadTime: i.leadTime.value }));
      } else if (firstProduct.length > 0) {
        newItems = firstProduct;
      }

      if (prlist.length === 0 && firstProduct.length === 0) {
        setError("Product table is empty");
        return;
      }
      let formData = new FormData();
      if (data?.vendor) {
        var valueWithItems = {
          ...value,
          rfqId: data?.id || "",
          vendorId: data?.vendor || "",
          isDirectQuote: false,
          products: newItems,
        };
      } else {
        valueWithItems = {
          ...value,
          rfqId: data?.id || "",
          isDirectQuote: false,
          products: newItems,
        };
      }
      formData.append("json_data", JSON.stringify(valueWithItems));

      if (selectedFile !== null) {
        selectedFile.forEach((file) => {
          formData.append("attachments", file);
        });
      } else {
        formData.append("attachments", []);
      }
      addFormData("/supplier-quotations/new-quotation", formData, resetForm);
    },
  });
  const { data: Purchaser } = UseDropDown("/user/purchaser/drop-down");

  const [prods, setProds] = useState({
    sno: "",
    productId: "",
    isAlternate: "",
    product_unit: "",
    leadTime: "",
    landedCost: "",
    quantity: "",
    price: "",
    notes: "",
    dutty: "",
    trans: "",
    sellingPrice: "",
  });

  const productForm = useFormik({
    enableReinitialize: true,
    initialValues: prods,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({}),
    onSubmit: (value, { resetForm }) => { },
  });

  const [prlist, setPrlist] = useState([]);
  const displayPrlist = useMemo(() => formatDisplaySno2(prlist || []), [prlist]);
  // console.log(displayPrlist,'ssssssssssssssssssss');

  const getRfq = (rfqId) => {
    if (rfqId !== "") {
      axiosInstance
        .get(`/supplier-quotations/RFQ-products/drop-down/${rfqId}`)
        .then((res) => {
          let data = res.data;
          if (data && data?.products) {
            const rawItems = data.products.map((i) => {
              const weight = i?.weight !== undefined && i?.weight !== null ? i.weight : "";
              const weightUnit = i?.weightUnit || i?.weight_unit || "kg";
              const freightCharge = i?.freightCharge !== undefined && i?.freightCharge !== null && i?.freightCharge !== ""
                ? i.freightCharge
                : (i?.freight !== undefined && i?.freight !== null && i?.freight !== "" ? i.freight : (i?.trans || ""));
              const dutyType = i?.dutyType || "percent";
              const duty = i?.duty !== undefined && i?.duty !== null && i?.duty !== ""
                ? i.duty
                : (i?.dutyValue !== undefined && i?.dutyValue !== null && i?.dutyValue !== ""
                  ? i.dutyValue
                  : (i?.dutty !== undefined && i?.dutty !== null ? i.dutty : ""));
              const localChargeType = i?.localChargeType || "cost";
              const localCharge = i?.localCharge !== undefined && i?.localCharge !== null && i?.localCharge !== ""
                ? i.localCharge
                : (i?.localChargeValue !== undefined && i?.localChargeValue !== null ? i.localChargeValue : "");

              return {
                ...i,
                weight,
                weightUnit,
                weight_unit: weightUnit,
                freightCharge,
                freight: freightCharge,
                trans: freightCharge,
                duty,
                dutyValue: duty,
                dutty: duty,
                dutyType,
                localCharge,
                localChargeValue: localCharge,
                localChargeType,
                leadTime: typeof i?.leadTime === "object" ? i?.leadTime : { value: i?.leadTime || "", label: i?.leadTime || "" },
              };
            });
            const calculated = rawItems.map((item) =>
              calculateProductRow(item, formik.values.exchangeRate)
            );
            setPrlist(calculated);
          }
        })
        .catch((err) => {
          console.log(err, "err");
        });
    }
  };

  useEffect(() => {
    if (formik.values.rfqId) {
      getRfq(formik.values.rfqId);
    }
  }, [formik.values.rfqId]);

  const [deletedItem, setDeletedItem] = useState([]);
  const [deletedItemDropDown, setDeletedItemDropDown] = useState([]);

  const handleDeleteItem = (indexToDelete) => {
    // 1. Update the prlist state using filter:
    const deletedItem = prlist.find((_, i) => i == indexToDelete);
    let newDD = {
      value: deletedItem.productId,
      label: deletedItem.product_name,
      unit: deletedItem.product_unit,
    };
    setData([...sortedProList, newDD]);

    const updatedPrlist = prlist.filter((_, index) => index !== indexToDelete);
    setPrlist(updatedPrlist);

    const deletedItems = prlist.filter((_, index) => index == indexToDelete);
    setDeletedItem((prevDeletedItems) => [
      ...prevDeletedItems,
      ...deletedItems,
    ]);

    // 3. Update the totalPrice state based on removed item's price and quantity:
    const removedItemPrice = parseFloat(prlist[indexToDelete].price || 0);
    const removedLandedCost = parseFloat(prlist[indexToDelete].landedCost || 0);

    const removedItemQuantity = parseFloat(prlist[indexToDelete].quantity || 0);
    const newTotalPrice =
      formik.values.totalPrice -
      (removedItemPrice + removedLandedCost * removedItemQuantity);

    // 4. Update the formik state for totalPrice using setFieldValue:
    formik.setFieldValue("totalPrice", newTotalPrice);
  };
  useEffect(() => {
    let tempData = [];
    deletedItem.forEach((item) => {
      let tempObject = { value: item.productId, label: item.product_name };
      tempData.push(tempObject);
    });
    setDeletedItemDropDown(tempData);
  }, [deletedItem]);

  const handleAddDelPro = () => {
    const selectedProductId = formik.values.productId;

    // Find the selected product's details from the deletedItemDropDown (or deletedItem array)
    const selectedProduct = deletedItem.find(
      (item) => item.productId === selectedProductId,
    );

    if (selectedProduct) {
      // Add the selected product to prList
      setPrlist((prevPrList) => [...prevPrList, selectedProduct]);

      // Optionally, remove the selected product from the dropdown after adding it to prList
      setDeletedItem((prevDeletedItems) =>
        prevDeletedItems.filter((item) => item.productId !== selectedProductId),
      );
    }
  };
  const calculateProductRow = (item, rate = formik.values.exchangeRate) => {
    const qty = Math.max(0, Number(item.quantity) || 0);
    const priceNum = item.price !== "" && item.price !== undefined && !isNaN(Number(item.price)) ? Number(item.price) : 0;
    const exRate = Number(rate) > 0 ? Number(rate) : 1;
    const convPrice = item.price !== "" && item.price !== undefined && !isNaN(Number(item.price))
      ? parseFloat((priceNum * exRate).toFixed(2))
      : (item.convPrice !== "" && item.convPrice !== undefined && !isNaN(Number(item.convPrice)) ? Number(item.convPrice) : 0);

    const weight = item.weight !== undefined && item.weight !== null ? item.weight : "";
    const weightUnit = item.weightUnit || item.weight_unit || "kg";
    const amount = parseFloat((convPrice * qty).toFixed(2));

    const freightCharge = item.freightCharge !== undefined && item.freightCharge !== null && item.freightCharge !== ""
      ? item.freightCharge
      : (item.freight !== undefined && item.freight !== null && item.freight !== ""
        ? item.freight
        : (item.trans !== undefined && item.trans !== null && item.trans !== "" ? item.trans : ""));
    const freightNum = Number(freightCharge) || 0;

    const totalWithFreight = parseFloat((amount + freightNum).toFixed(2));

    const dutyType = item.dutyType || "percent";
    const duty = item.duty !== undefined && item.duty !== null && item.duty !== ""
      ? item.duty
      : (item.dutyValue !== undefined && item.dutyValue !== null && item.dutyValue !== ""
        ? item.dutyValue
        : (item.dutty !== undefined && item.dutty !== null && item.dutty !== "" ? item.dutty : ""));
    const dutyValNum = Number(duty) || 0;

    let dutyAmount = 0;
    if (dutyType === "percent") {
      dutyAmount = parseFloat(((totalWithFreight * dutyValNum) / 100).toFixed(2));
    } else {
      dutyAmount = parseFloat(dutyValNum.toFixed(2));
    }

    const localChargeType = item.localChargeType || "cost";
    const localCharge = item.localCharge !== undefined && item.localCharge !== null && item.localCharge !== ""
      ? item.localCharge
      : (item.localChargeValue !== undefined && item.localChargeValue !== null && item.localChargeValue !== "" ? item.localChargeValue : "");
    const localChargeValNum = Number(localCharge) || 0;

    let localChargeAmount = 0;
    if (localChargeType === "percent") {
      localChargeAmount = parseFloat(((totalWithFreight * localChargeValNum) / 100).toFixed(2));
    } else {
      localChargeAmount = parseFloat(localChargeValNum.toFixed(2));
    }

    const rowTotal = parseFloat((totalWithFreight + dutyAmount + localChargeAmount).toFixed(2));
    const finalUnitPrice = qty > 0 ? parseFloat((rowTotal / qty).toFixed(2)) : 0.0;
    const landedCost = qty > 0 ? parseFloat(((freightNum + dutyAmount + localChargeAmount) / qty).toFixed(2)) : 0.0;

    return {
      ...item,
      quantity: item.quantity,
      price: item.price,
      convPrice: convPrice,
      weight: weight,
      weightUnit: weightUnit,
      weight_unit: weightUnit,
      amount: amount,
      freightCharge: freightCharge,
      freight: freightCharge,
      trans: freightNum,
      totalWithFreight: totalWithFreight,
      duty: duty,
      dutyValue: duty,
      dutyType: dutyType,
      dutty: dutyType === "percent" ? dutyValNum : (totalWithFreight > 0 ? parseFloat(((dutyAmount / totalWithFreight) * 100).toFixed(2)) : 0),
      dutyAmount: dutyAmount,
      localCharge: localCharge,
      localChargeValue: localCharge,
      localChargeType: localChargeType,
      localChargeAmount: localChargeAmount,
      landedCost: landedCost,
      finalUnitPrice: finalUnitPrice,
      sellingPrice: finalUnitPrice,
      rowTotal: rowTotal,
      total: rowTotal,
    };
  };

  const handlePriceChange = (e, index) => {
    const updatedItems = [...prlist];
    updatedItems[index].price = e.target.value;
    const recalculated = calculateProductRow(updatedItems[index]);
    updatedItems[index] = recalculated;
    setPrlist(updatedItems);
  };

  const handleWeightChange = (value, index) => {
    const updatedItems = [...prlist];
    updatedItems[index].weight = value;
    const recalculated = calculateProductRow(updatedItems[index]);
    updatedItems[index] = recalculated;
    setPrlist(updatedItems);
  };

  const handleWeightUnitChange = (value, index) => {
    const updatedItems = [...prlist];
    updatedItems[index].weightUnit = value;
    updatedItems[index].weight_unit = value;
    const recalculated = calculateProductRow(updatedItems[index]);
    updatedItems[index] = recalculated;
    setPrlist(updatedItems);
  };

  const handleFreightChange = (value, index) => {
    const updatedItems = [...prlist];
    updatedItems[index].freightCharge = value;
    updatedItems[index].freight = value;
    updatedItems[index].trans = value;
    const recalculated = calculateProductRow(updatedItems[index]);
    updatedItems[index] = recalculated;
    setPrlist(updatedItems);
  };

  const handleDutyValueChange = (value, index) => {
    const updatedItems = [...prlist];
    updatedItems[index].duty = value;
    updatedItems[index].dutyValue = value;
    updatedItems[index].dutty = value;
    const recalculated = calculateProductRow(updatedItems[index]);
    updatedItems[index] = recalculated;
    setPrlist(updatedItems);
  };

  const handleDutyTypeToggle = (index) => {
    const updatedItems = [...prlist];
    const currentType = updatedItems[index].dutyType || "percent";
    updatedItems[index].dutyType = currentType === "cost" ? "percent" : "cost";
    const recalculated = calculateProductRow(updatedItems[index]);
    updatedItems[index] = recalculated;
    setPrlist(updatedItems);
  };

  const handleLocalChargeValueChange = (value, index) => {
    const updatedItems = [...prlist];
    updatedItems[index].localCharge = value;
    updatedItems[index].localChargeValue = value;
    const recalculated = calculateProductRow(updatedItems[index]);
    updatedItems[index] = recalculated;
    setPrlist(updatedItems);
  };

  const handleLocalChargeTypeToggle = (index) => {
    const updatedItems = [...prlist];
    const currentType = updatedItems[index].localChargeType || "cost";
    updatedItems[index].localChargeType = currentType === "cost" ? "percent" : "cost";
    const recalculated = calculateProductRow(updatedItems[index]);
    updatedItems[index] = recalculated;
    setPrlist(updatedItems);
  };

  const handleduttyChange = (e, index) => {
    handleDutyValueChange(e.target.value, index);
  };

  const handleCostChange = (e, index) => {
    const updatedItems = [...prlist];
    updatedItems[index].landedCost = e.target.value || 0;
    setPrlist(updatedItems);
  };

  useEffect(() => {
    const totalPrice = prlist?.reduce((total, item) => {
      return (total || 0) + (Number(item.total || item.rowTotal || 0));
    }, 0);

    formik.setFieldValue("totalPrice", totalPrice);
  }, [prlist]);

  useEffect(() => {
    if (prlist && prlist.length > 0) {
      const updated = prlist.map((item) =>
        calculateProductRow(item, formik.values.exchangeRate)
      );
      setPrlist(updated);
    }
  }, [formik.values.exchangeRate]);

  const handleQuantityChange = (index, newQuantity) => {
    const updatedItems = [...prlist];
    updatedItems[index].quantity = newQuantity;
    const recalculated = calculateProductRow(updatedItems[index]);
    updatedItems[index] = recalculated;
    setPrlist(updatedItems);
  };

  const handleIncrement = (index) => {
    handleQuantityChange(index, Number(prlist[index].quantity || 0) + 1);
  };

  const handleDecrement = (index) => {
    handleQuantityChange(index, Math.max(1, Number(prlist[index].quantity || 0) - 1));
  };

  const handleInputChange = (event, index) => {
    const value = Math.max(Number(event.target.value), 0);
    handleQuantityChange(index, value);
  };
  const handleLeadTimeChange = (value, index) => {
    const updatedItems = [...prlist];
    updatedItems[index].leadTime = value;
    setPrlist(updatedItems);
  };

  const handleProductUnitChange = (value, index) => {
    const updatedItems = [...prlist];
    updatedItems[index].product_unit = value?.value;
    setPrlist(updatedItems);
  };

  const handleAdd = (index) => {
    if (
      productForm.values.productId &&
      productForm.values.quantity &&
      productForm.values.price
    ) {
      const selectedProduct = sortedProList.find(
        (i) => i.value === productForm.values.productId,
      );
      let lead_time = {
        label: productForm.values.leadTime,
        value: productForm.values.leadTime,
      };

      // Calculate new sno based on the existing item
      // let newSno;
      // if (formik.values.isDirectQuote === false) {
      //   const baseSno = prlist[index].sno;
      //   const subIndex = prlist.filter((item) =>
      //     String(item.sno).startsWith(baseSno)
      //   ).length;
      //   newSno = `${baseSno}${String.fromCharCode(64 + subIndex)}`; // 97 is ASCII code for 'a'
      // }
      let newSno;
      if (formik.values.isDirectQuote === false) {
        const baseSno = prlist[index].sno;

        // Find all related items
        const relatedItems = prlist.filter(
          (item) =>
            String(item.sno).startsWith(baseSno) && item.sno !== baseSno,
        );

        newSno = `${baseSno}${String.fromCharCode(65 + relatedItems.length)}`;
      }

      const newItem = {
        sno: newSno,
        productId: productForm.values.productId,
        leadTime: lead_time,
        price: parseFloat(productForm.values.price).toFixed(2),
        isAlternate: formik.values.isDirectQuote == false ? true : false,
        product_name: selectedProduct.label,
        product_unit: productForm.values.product_unit,
        quantity: productForm.values.quantity,
        notes: productForm.values.notes,
        duty: productForm.values.dutty || "",
        dutyValue: productForm.values.dutty || "",
        dutty: productForm.values.dutty || "",
        dutyType: "percent",
        freightCharge: "",
        freight: "",
        trans: 0.0,
        localCharge: "",
        localChargeValue: "",
        localChargeType: "cost",
        weight: "",
        weightUnit: "kg",
        weight_unit: "kg",
        landedCost: 0.0,
        convPrice: parseFloat(
          parseFloat(productForm.values.price).toFixed(2) *
          (formik.values.exchangeRate > 0 ? formik.values.exchangeRate : 1),
        ).toFixed(2),
      };

      // let NewValue = prlist[index].sno;

      // let preFilter = prlist.map((item) => {
      //   let tempvalue = { ...item };
      //   tempvalue.sno = `${item.sno}`;
      //   return tempvalue;
      // });
      // let Filter =
      //   preFilter.filter((item) => item.sno.includes(`${NewValue}`)).length ||
      //   0;

      // let newPrList = [...prlist];
      // newPrList.splice(index + Filter, 0, newItem);
      // console.log("Alternates",newPrList);

      // setPrlist(newPrList);
      // handleTransNewPR(newPrList);

      // let updatedItems = Item.filter(
      //   (it) => it.value !== productForm.values.productId
      // );
      // setData(updatedItems);

      let insertionIndex = index + 1;
      while (
        insertionIndex < prlist.length &&
        String(prlist[insertionIndex].sno).startsWith(prlist[index].sno)
      ) {
        insertionIndex++;
      }

      // Insert the new item at the correct position
      const newPrList = [...prlist];
      newPrList.splice(insertionIndex, 0, newItem);

      setPrlist(newPrList);

      // Update the remaining part
      const updatedItems = Item.filter(
        (it) => it.value !== productForm.values.productId,
      );
      setData(updatedItems);

      // Clear the form fields
      productForm.values.productId = "";
      productForm.values.quantity = "";
      productForm.values.isAlternate = "";
      productForm.values.notes = "";
      productForm.values.trans = "";
      productForm.values.dutty = "";
      productForm.values.sellingPrice = "";

      productForm.values.leadTime = "";
      productForm.values.landedCost = "";
      productForm.values.product_unit = "";
      productForm.values.price = "";
      if (formik.values.isDirectQuote === false) {
        setShowForm(!showForm);
      }
    }
  };

  const [showPopup, setShowPopup] = useState(false);
  const [newProduct, setNewProduct] = useState({
    productName: "",
    unit: "",
    category: "",
    subCategory: "",
  });

  const togglePopup = () => {
    setShowPopup(!showPopup);
  };

  const resetForm = () => {
    formik.values.productName = "";
    formik.values.unit = "";
    formik.values.category = "";
    formik.values.subCategory = "";
    setShowPopup(false);
  };

  const handlePopupSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append(
      "itemDetails",
      JSON.stringify({
        productName: formik.values.productName,
        unit: formik.values.unit,
        category: formik.values.category,
        subCategory: formik.values.subCategory,
      }),
    );

    try {
      const response = await axiosInstance.post("/items/new-item", formData);
      const createdProduct = response.data?.data;

      setData((prevProducts) => [
        {
          label: formik.values.productName,
          value: createdProduct.id,
          unit: createdProduct.unit,
        }, // Add the new product at the start
        ...prevProducts,
      ]);

      resetForm();
    } catch (error) {
      console.error("Error creating new product:", error);
    }
  };
  const [showForm, setShowForm] = useState(false);
  const [selectedProductIndex, setSelectedProductIndex] = useState(null);

  const toggleForm = (idx) => {
    setShowForm(!showForm);
    setSelectedProductIndex(idx);
  };

  const [firstProds, setFirstProds] = useState({
    sno: "",
    productId: "",
    leadTime: "",
    landedCost: "",
    quantity: "",
    price: "",
  });
  const [firstProduct, setFirstProduct] = useState([]);
  function handleAddPro() {
    const selectedProduct = sortedProList.find(
      (i) => i.value === productForm.values.productId,
    );
    const newItem = {
      sno: firstProduct.length + 1,
      productId: productForm?.values?.productId,
      leadTime: productForm?.values?.leadTime,
      landedCost: productForm?.values?.landedCost || 0,

      quantity: productForm?.values?.quantity || 1,
      price: productForm?.values?.price,
      product_name: selectedProduct?.label,
      product_unit: selectedProduct?.unit,
    };

    if (
      firstProduct.some(
        (item) => item.productId == productForm.values.productId,
      )
    ) {
      let tempValue = [...firstProduct];
      let filterValue = tempValue.find(
        (item) => item.productId == productForm.values.productId,
      );
      filterValue.quantity = filterValue.quantity + newItem?.quantity;
      filterValue.price = filterValue.price + Number(newItem?.price || 0);
      filterValue.landedCost = filterValue.landedCost + newItem?.landedCost;
      setFirstProduct(tempValue);
      productForm.values.productId = "";
      productForm.values.quantity = "";
      productForm.values.leadTime = "";
      productForm.values.price = "";
      productForm.values.landedCost = "";
    } else {
      if (productForm?.values?.productId != "") {
        if (productForm?.values?.price != "") {
          setFirstProduct([...firstProduct, newItem]);
          productForm.values.productId = "";
          productForm.values.quantity = "";
          productForm.values.leadTime = "";
          productForm.values.price = "";
          productForm.values.landedCost = "";
        } else {
          toast.open({
            type: "warning",
            message: "Warning",
            description: "Please Enter all mandatory fields to add product",
          });
        }
      } else {
        toast.open({
          type: "warning",
          message: "Warning",
          description: "Please choose Product to  the list",
        });
      }
    }
  }

  function handleDeletePro(indexToDelete) {
    const updatedProducts = firstProduct.filter((_, i) => i !== indexToDelete);
    setFirstProduct(updatedProducts);
  }

  useEffect(() => {
    if (prlist?.length > 0) {
      setError("");
    }
  }, [prlist]);

  const formatNumberWithCommas = (number) => {
    return number.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  useEffect(() => {
    const totalPrice = firstProduct.reduce((total, item) => {
      return (
        total +
        (parseFloat(item.price) + parseFloat(item.landedCost)) *
        parseFloat(item.quantity || 0)
      );
    }, 0);

    formik.setFieldValue("totalPrice", totalPrice);
  }, [firstProduct]);

  const {
    category: itemsCategory,
    subCategory: itemsSubCategory,
    getCategory,
    fetchSubCategory,
  } = UseCatSubCatDropDown(
    "/category/ItemCategory",
    "ItemCategory",
    formik?.values?.category,
  );

  const [prRequiredError, setPrRequiredError] = useState(false);

  const handleCheckboxChange = (e) => {
    if (!formik.values.prId) {
      // Set the error state if prId is empty
      setPrRequiredError(true);
      return;
    }
    // If prId is not empty, reset the error and update the checkbox value
    setPrRequiredError(false);
    formik.setFieldValue("purchaserChecked", e.target.checked);
  };

  const [vendorlist, setVendorlist] = useState([]);

  function getVendor(prId) {
    axiosInstance
      .get(`/supplier-quotations/vendor/drop-down/${prId}`)
      .then((response) => {
        let tempData = [];
        if (response.data) {
          let x = response.data;

          x.map((item) => {
            let y = {
              value: item.id,
              label: item.name,
            };
            tempData.push(y);
          });

          setVendorlist(tempData);
        }
      })
      .catch((error) => {
        console.log("Error:", error);
      });
  }
  const [purchaserlist, setPurchaserlist] = useState([]);
  const [supplierCurrency, setSupplierCurrency] = useState([]);

  function getPurchaser(prId) {
    axiosInstance
      .get(`/supplier-quotations/purchaser/drop-down/${prId}`)
      .then((response) => {
        let tempData = [];
        if (response.data) {
          let x = response.data;

          x.map((item) => {
            let y = {
              value: item.id,
              label: item.name,
            };
            tempData.push(y);
          });

          setPurchaserlist(tempData);
        }
      })
      .catch((error) => {
        console.log("Error:", error);
      });
  }
  useEffect(() => {
    if (formik.values.prId && formik.values.purchaserChecked === true) {
      getPurchaser(formik.values.prId);
    } else if (formik.values.prId && !formik.values.purchaserChecked) {
      getVendor(formik.values.prId);
    }
  }, [formik.values.prId, formik.values.purchaserChecked]);

  const [rfq, setRFQs] = useState([]); // State for storing RFQs

  const getPr = (prId, vendorId) => {
    if (prId !== "" && vendorId !== "") {
      axiosInstance
        .get(`/rfq/drop-down/by-supplier/${prId}/${vendorId}`)
        .then((res) => {
          const data = res.data;
          const rfqOptions = data.map((item) => ({
            value: item.id,
            label: item.name,
          }));
          setRFQs(rfqOptions);
        })
        .catch((err) => {
          console.log(err, "err");
        });
    }
  };

  useEffect(() => {
    if (!formik.values.purchaserChecked) {
      if (formik.values.prId && formik.values.vendorId) {
        getPr(formik.values.prId, formik.values.vendorId);
      }
    }
  }, [formik.values.prId, formik.values.vendorId]);

  useEffect(() => {
    if (rfq?.length == 1) {
      formik.setFieldValue("rfqId", rfq[0].value);
    }
  }, [rfq]);

  const [selectedCurrency, setSelectedCurrency] = useState("");
  function getCurrenctFind(id) {
    const label = currency.find((currency) => currency.value === id);
    setSelectedCurrency(label?.label);
  }

  const [exChange, setExchage] = useState("");
  function exchangeRate(id) {
    axiosInstance
      .get(`/currency/${id}`)
      .then((res) => {
        setExchage(res?.data?.data?.exchangeRate);
        formik.setFieldValue(
          "exchangeRate",
          res?.data?.data?.exchangeRate > 0
            ? res?.data?.data?.exchangeRate
            : "",
        );
      })
      .catch((err) => {
        console.log(err);
      });
  }

  useEffect(() => {
    getCurrenctFind(formik?.values?.currencyId);
    formik?.values?.currencyId && exchangeRate(formik?.values?.currencyId);
  }, [formik?.values?.currencyId]);

  // useEffect(()=>{
  //   const rate = parseFloat(exChange);
  //     console.log("ExRate....", rate);

  //     if (exChange > 0) {
  //       // Ensure prlist is defined and properly mapped
  //       const updatedList = prlist?.map((item) => ({
  //         ...item,
  //         convPrice: parseFloat(item.price * rate).toFixed(2),
  //       }));

  //       console.log("Updated List:", updatedList);

  //       // Update the prlist state
  //       setPrlist(updatedList);

  //       // Wait for prlist state to update before handling transactions
  //       setTimeout(() => {
  //         handleTrans();
  //       }, 0); // Ensures state update reflects before using it
  //     }
  // },[exChange])

  const getRFQPo = (prId, purchaser) => {
    if (prId !== "" && purchaser !== "") {
      axiosInstance
        .get(`/rfq/drop-down/by-purchaser/${prId}/${purchaser}`)
        .then((res) => {
          const data = res.data;
          const rfqOptions = data.map((item) => ({
            value: item.id,
            label: item.name,
          }));
          setRFQs(rfqOptions);
        })
        .catch((err) => {
          console.log(err, "err");
        });
    }
  };

  useEffect(() => {
    if (formik.values.prId && formik.values.purchaser) {
      getRFQPo(formik.values.prId, formik.values.purchaser);
    }
  }, [formik.values.prId, formik.values.purchaser]);

  useEffect(() => {
    formik.setFieldValue("purchaser", "");
    formik.setFieldValue("rfqId", "");

    formik.setFieldValue("vendorId", "");
  }, [formik.values.purchaserChecked]);

  function handleImageChange(e) {
    const maxFileSize = 200000000; // 200 MB
    const files = Array.from(e.target.files);
    let fileArr = [];
    files.map((item) => {
      if (item.size < maxFileSize) {
        fileArr.push(item);
      } else {
        toast.open({
          type: "warning",
          message: `File Size to big`,
          description: `${item.name} is Removed and not Uploaded`,
        });
      }
    });
    let tempArr = [];
    setSelectedFile(fileArr);
    files.map((item) => {
      if (item.size < maxFileSize) {
        let fileName = item?.name;
        tempArr.push(fileName);
      }
    });
    setImage(tempArr);
  }

  const removeImages = (value) => {
    let List = selectedFile.filter((item) => item?.name !== value);
    setSelectedFile([...List]);
    let tempArr = [];
    List.map((item) => {
      let fileName = item?.name;
      tempArr.push(fileName);
    });
    setImage(tempArr);
  };

  const handleNoteChange = (e, index) => {
    const updatedItems = [...prlist];
    updatedItems[index].notes = e.target.value;
    setPrlist(updatedItems);
  };

  const [isPopupVisible, setIsPopupVisible] = useState(false);

  const popupCalculate = () => {
    setIsPopupVisible(!isPopupVisible);
  };

  const sumOfTotals = Array.isArray(data)
    ? data.reduce(
      (sum, { quantity, convPrice }) => sum + (quantity * convPrice || 0),
      0,
    )
    : 0;

  const formulaValue =
    sumOfTotals > 0
      ? ((parseFloat(formik.values.total) || 0) / sumOfTotals) * 100
      : 0;

  useMemo(() => {
    if (formik.values.exchangeRate && prlist.length > 0) {
      const rate = formik.values.exchangeRate;
      const updatedPrlist = prlist.map((item) => calculateProductRow(item, rate));
      setPrlist(updatedPrlist);
    }
  }, [formik.values.exchangeRate]);

  const existingProductNames = useMemo(
    () => prlist.map((product) => product.product_name.toLowerCase()),
    [prlist],
  );

  useEffect(() => {
    const filterdItem = Item.filter(
      (item) => !existingProductNames.includes(item.label.toLowerCase()),
    );
    if (Item) {
      const union = Array.from(
        new Map(
          [...filterdItem, ...oldData].map((item) => [item.value, item]),
        ).values(),
      );
      let data = union.sort((a, b) => a.label.localeCompare(b.label));
      setSortedProList(data);
    }
  }, [Item]);

  useEffect(() => {
    if (productForm.values.productId) {
      const findValue = sortedProList.filter(
        (v) => productForm.values?.productId == v.value,
      );
      setOldData(findValue);
    }
    console.log("Testing", productForm.values.productId);
  }, [productForm.values.productId]);

  const [sortedVendors, setSortedVendors] = useState([]);
  const [oldDataSuppliers, setOldDataSuppliers] = useState([]);
  useEffect(() => {
    if (vendors) {
      const union = Array.from(
        new Map(
          [...vendors, ...oldDataSuppliers].map((item) => [item.value, item]),
        ).values(),
      );
      const sortedData = union.sort((a, b) => a.label.localeCompare(b.label));
      setSortedVendors(sortedData);
    }
  }, [vendors, oldDataSuppliers]);

  useEffect(() => {
    if (formik.values.vendorId) {
      const selectedId = formik.values.vendorId;
      const selectedItem = sortedVendors.find(
        (item) => item.value === selectedId,
      );

      if (selectedItem) {
        setOldDataSuppliers((prevOldData) => {
          const exists = prevOldData.some((item) => item.value === selectedId);
          if (!exists) {
            return [...prevOldData, selectedItem];
          }
          return prevOldData;
        });
      }

      setSearchSupplier(""); // Clear search input
    }
  }, [formik.values.vendorId, sortedVendors]);

  return (
    <div className="w-full h-full py-2 px-4 ">
      <div className="flex justify-between ">
        <Breadcrumb
          items={[
            { name: "RFQ", link: "/procurement/rfq/" },
            { name: "Create Quote" },
          ]}
        />
        <BackButton />
      </div>
      <form onSubmit={formik.handleSubmit}>
        <div className="w-full mx-auto h-[calc(100vh-145px)] bg-white rounded-md overflow-hidden mt-4">
          <div className=" w-full h-full py-4 px-3 flex justify-start content-start flex-wrap  overflow-y-auto">
            <NuInput
              label="Quotation Reference"
              type="text"
              formik={formik}
              placeholder="Reference"
              name="ref"
              width="w-full md:w-1/2 lg:w-1/3"
              isRequired={true}
            />
            {!data?.vendor && (
              <TwoNEW
                type="text"
                label="Supplier"
                placeholder="Choose"
                Options={sortedVendors}
                formik={formik}
                name="vendorId"
                width="w-full md:w-1/2 lg:w-1/3"
                isRequired={true}
                setSearch={setSearchSupplier}
              />
            )}
            {/* <NuDate
              label="Quote Date"
              placeholder="dd/mm/yyyy"
              formik={formik}
              name="quoteDate"
              width="w-full md:w-1/2 lg:w-1/3"
            /> */}
            <NuDate
              label="Quotation Received Date"
              placeholder="dd/mm/yyyy"
              formik={formik}
              name="dateReceived"
              width="w-full md:w-1/2 lg:w-1/3"
            />

            <DropDownAddMetaData
              label="Delivery Terms"
              placeholder="Choose"
              Options={DeliveryTerms}
              formik={formik}
              name="deliverTerms"
              width="w-full md:w-1/2 lg:w-1/3"
              getFunc={refDeliveryTerms}
              displayProperty={"Delivery Terms"}
              propertyName={"DeliveryTerms_Supplierqoutes"}
            />

            <DropDownAddMetaData
              label="Payment Terms"
              placeholder="Choose"
              Options={PaymentTerms}
              formik={formik}
              name="paymentTerms"
              width="w-full md:w-1/2 lg:w-1/3"
              getFunc={refPaymentTerms}
              displayProperty={"Payment Terms"}
              propertyName={"PaymentTerms_Supplierqoutes"}
            />

            <DropDownAddMetaData
              label="Payment Method"
              placeholder="Choose"
              Options={paymentMethod}
              formik={formik}
              name="paymentMethod"
              width="w-full md:w-1/2 lg:w-1/3"
              getFunc={refpaymentMethod}
              displayProperty={"Payment Method"}
              propertyName={"paymentMethod_supplierquotes"}
            />

            <DropDownAddMetaData
              label="Quotation Validity"
              placeholder="Choose"
              Options={Validity}
              formik={formik}
              name="validity"
              width="w-full md:w-1/2 lg:w-1/3"
              getFunc={refValidity}
              displayProperty={"Quotation Validity"}
              propertyName={"Validity_Supplierquotes"}
            />

            <DropDownAddCurrency
              label="Currency"
              placeholder="Choose"
              Options={currency}
              formik={formik}
              name="currencyId"
              width="w-full md:w-1/2 lg:w-1/3"
              getFunc={refCurrency}
              isRequired={true}
            />

            <NuInput
              label="Exchange Rate"
              type="text"
              formik={formik}
              placeholder="Exchange Rate"
              name="exchangeRate"
              width="w-full md:w-1/2 lg:w-1/3"
              disabled={exChange === "" || !exChange ? false : true}
            />

            <NuTextArea
              label="Special Notes From Supplier"
              type="text"
              formik={formik}
              placeholder="Special Notes From Supplier"
              name="specialNotes"
              width="w-full md:w-1/2 lg:w-1/3"
              new_width="w-full md:w-1/2 lg:w-2/3"
            />
            {/* <NuTextArea
              label="Comments"
              type="text"
              formik={formik}
              placeholder="Comments"
              name="comments"
              width="w-full md:w-1/2 lg:w-1/3"
            /> */}
            <div className="w-full">
              <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-[#048178] decoration-2 underline-offset-4">
                SQ Attachement :
              </p>
            </div>
            <Attachement
              handleChange={handleImageChange}
              preview={image || ""}
              width="w-full"
              label="Attach"
              multiple={true}
              removeImages={removeImages}
            />
            {/* </div> */}
            <div className="w-full h-[1px] opacity-30 bg-[#C4C2C2] my-6 mx-auto "></div>
            {deletedItemDropDown.length > 0 ? (
              <div className="w-full flex justify-start gap-2">
                <FormikSelectTwo
                  type="text"
                  label="Product"
                  placeholder="Product"
                  Options={deletedItemDropDown}
                  formik={formik}
                  name="productId"
                  width="w-full md:w-1/2 lg:w-[67%]"
                />
                <button
                  onClick={handleAddDelPro}
                  type="button"
                  className=" p-1 mt-[44px] m-1 text-center h-8 cursor-pointer bg-[#048178] border border-solid border-white  text-xs font-medium  text-white  rounded-lg "
                >
                  Add
                </button>
              </div>
            ) : null}
            {(showForm || formik.values.isDirectQuote) && (
              <div className="w-full rounded-md flex flex-col px-1 md:flex-row gap-y-2 md:gap-y-0 justify-start items-end gap-1 border border-solid">
                <SelectProductWithError
                  type="text"
                  label="Product "
                  placeholder="Product "
                  Options={sortedProList}
                  formik={productForm}
                  name="productId"
                  width="w-full md:w-1/2 lg:w-[40%]"
                  ErrMessage={""}
                  px="0"
                  //  handleClick={()=>{}}
                  hasAddButton={true}
                  setSearch={setSearch}
                  handleClick={togglePopup}
                />
                {/* <button
                  onClick={togglePopup}
                  type="button"
                  className="px-3 mb-2 ml-2 text-center py-1.5 cursor-pointer bg-[#048178] border border-solid border-white  text-white font-semibold rounded-lg"
                >
                  +
                </button> */}
                {/* <button
          onClick={togglePopup}
          type="button"
          className="w-6 text-center h-6 cursor-pointer mb-10 mr-4 bg-[#048178] flex justify-center items-center border border-solid border-white text-white font-semibold rounded-lg"
        >
          +
        </button> */}
                <DropDownAddMetaData
                  label="Unit"
                  placeholder="Choose"
                  Options={Unit}
                  formik={productForm}
                  name="product_unit"
                  width="w-full md:w-1/2 lg:w-1/4"
                  getFunc={refUnit}
                  displayProperty={"Add Unit"}
                  propertyName={"Unit_item"}
                />
                <NuInput
                  label="Quantity"
                  type="number"
                  formik={productForm}
                  placeholder="Quantity"
                  name="quantity"
                  px="2"
                  width="w-full md:w-1/2 lg:w-1/4 "
                  isRequired={true}
                />
                <DropDownAddMetaData
                  label="Lead Time"
                  placeholder="Choose"
                  Options={leadTime}
                  formik={productForm}
                  name="leadTime"
                  width="w-full md:w-1/2 lg:w-1/4"
                  getFunc={refLeadTime}
                  displayProperty={"Lead Time"}
                  propertyName={"LeadTime_Supplierqoutes"}
                />
                <NuInput
                  label="Price"
                  type="number"
                  formik={productForm}
                  placeholder="0.00"
                  name="price"
                  px="2"
                  width="w-full md:w-1/2 lg:w-1/4"
                  isRequired={true}
                />
                <NuInput
                  label="Dutty"
                  type="number"
                  formik={productForm}
                  placeholder="0.00"
                  name="dutty"
                  px="2"
                  width="w-full md:w-1/2 lg:w-1/4"
                // isRequired={true}
                />
                <button
                  type="button"
                  onClick={() =>
                    formik?.values?.isDirectQuote === false
                      ? handleAdd(selectedProductIndex)
                      : handleAddPro()
                  }
                  className="px-2 mb-3 text-center py-2 cursor-pointer bg-[#048178] border border-solid border-white  text-white text-xs font-semibold rounded-lg "
                >
                  Add
                </button>
              </div>
            )}
            <div
              className={`lg:w-[calc(100vw-280px)] overflow-auto h-[calc(100vh-190px)] relative`}
            >
              <table className="table-auto relative  border-collapse bg-white mt-2 z-0">
                <thead className="bg-baseColor-primary lg:sticky top-0 text-white text-xs 2xl:text-sm z-[3] ">
                  <tr>
                    <th className=" lg:sticky  left-0 bg-baseColor-primary z-[3]  h-10    ">
                      <div className=" flex  w-full  items-center">
                        <div className=" w-[80px]  gap-1 flex justify-center items-center text-center ">
                          <button
                            type="button"
                            onClick={toggleEdit}
                            className="text-center text-white text-xs font-medium"
                          >
                            <EditIcon
                              color="white"
                              width={"12"}
                              height={"12"}
                            />
                          </button>
                          S.N.
                        </div>
                        <div className=" w-[450px]  flex  pl-2 text-left ">
                          Product
                        </div>
                      </div>
                    </th>
                    <th className="  ">
                      <div className=" flex  w-full  items-center">
                        <div className=" w-[130px]   flex justify-center items-center text-center ">
                          Unit
                        </div>
                        <div className=" w-[130px]  flex justify-center items-center text-center ">
                          Quantity
                        </div>
                        <div className=" w-[130px]  flex justify-center items-center text-center ">
                          Lead Time
                        </div>
                        <div className=" w-[160px]  flex justify-center items-center text-center ">
                          Unit Price
                        </div>
                        <div className=" w-[160px]  flex justify-center items-center text-center ">
                          Conv. Price
                        </div>
                        <div className=" w-[150px]  flex justify-center items-center text-center ">
                          Weight
                        </div>
                        <div className=" w-[140px]  flex justify-center items-center text-center ">
                          Amount
                        </div>
                        <div className=" w-[140px]  flex justify-center items-center text-center ">
                          Freight Charge
                        </div>
                        <div className=" w-[160px]  flex justify-center items-center text-center ">
                          Total with Freight
                        </div>
                        <div className=" w-[180px]  flex justify-center items-center text-center ">
                          Duty
                        </div>
                        <div className=" w-[180px]  flex justify-center items-center text-center ">
                          Local Charge
                        </div>
                        <div className=" w-[150px]  flex justify-center items-center text-center ">
                          Final Unit Price
                        </div>
                        <div className=" w-[150px]  flex justify-center items-center text-center ">
                          Total
                        </div>
                        <div className=" w-[70px]  flex justify-center items-center text-center ">
                          Action
                        </div>
                      </div>
                    </th>
                  </tr>
                </thead>
                {prlist?.length > 0 || firstProduct.length > 0 ? (
                  <tbody className="z-[0]">
                    {displayPrlist.map((list, index) => (
                      <tr
                        key={index}
                        className="  text-xs 2xl:text-sm border-collapse border border-slate-300"
                      >
                        <td className={` text-center lg:sticky left-0  z-[1]`}>
                          <div className=" flex  items-center min-h-16">
                            <div className=" w-[80px] text-center min-h-16 bg-white  flex justify-center items-center">
                              {list?.isAlternate == false &&
                                formik.values.isDirectQuote == false && (
                                  <button
                                    type="button"
                                    onClick={() => toggleForm(index)}
                                    className="font-semibold px-1.5 py-0.5 bg-blue-600 text-white mr-2 rounded-lg ml-[-5px]"
                                  >
                                    <p>+</p>
                                  </button>
                                )}
                              {list?.display_sno}
                            </div>
                            <div className=" w-[450px] bg-white  text-left line-clamp-6 min-h-16 max-h-[6.5rem]     px-2 items-center">
                              <p className="text-left  text-xs font-medium text-[#111537] p-1">
                                {list?.product_name}
                              </p>

                              <p className="flex">
                                <p className="text-[12px]  font-thin mt-1">
                                  {" "}
                                  Notes :
                                </p>
                                {isEditing && (
                                  <input
                                    type="text"
                                    className="w-[65%] py-1 text-left px-1  border border-gray-100 text-xs font-light "
                                    name="notes"
                                    placeholder="Enter here..."
                                    value={list.notes || ""}
                                    onChange={(e) => handleNoteChange(e, index)}
                                  />
                                )}
                              </p>
                              {list?.isAlternate ? (
                                <p className="text-left text-[#65667b] text-[10px] md:text-[10px] lg:text-[8px] xl:text-[10px] font-light">
                                  (Alternate)
                                </p>
                              ) : (
                                <></>
                              )}
                            </div>
                          </div>
                        </td>
                        <td className="bg-white">
                          <div className="w-full flex items-center">
                            <td
                              className={`py-2 text-center text-xs font-medium text-[#111537]  w-[130px] px-2 border-slate-300`}
                            >
                              <div className="  ">
                                <Select
                                  value={
                                    Unit.find(
                                      (item) =>
                                        item?.value == list.product_unit,
                                    ) || list.product_unit
                                  }
                                  options={isEditing ? Unit : []}
                                  className="w-full text-xs"
                                  menuPlacement="auto"
                                  menuPosition="fixed"
                                  menuPortalTarget={typeof document !== "undefined" ? document.body : null}
                                  styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    menu: (base) => ({ ...base, zIndex: 9999 }),
                                  }}
                                  onChange={(value) =>
                                    handleProductUnitChange(value, index)
                                  }
                                  isDisabled={!isEditing}
                                />
                              </div>
                            </td>
                            <td
                              className={`py-2 text-center text-xs font-medium text-[#111537] border-collapse  border-y-0 w-[130px] px-2 `}
                            >
                              {isEditing ? (
                                <>
                                  <button
                                    type="button"
                                    className="border rounded-full p-1"
                                    onClick={() => handleDecrement(index)}
                                  >
                                    -
                                  </button>
                                  <input
                                    type="number"
                                    className="w-[50%] text-center  text-xs font-medium text-[#111537]"
                                    name="quantity"
                                    value={list.quantity}
                                    onChange={(e) =>
                                      handleInputChange(e, index)
                                    }
                                  />
                                  <button
                                    type="button"
                                    className="border rounded-full p-1"
                                    onClick={() => handleIncrement(index)}
                                  >
                                    +
                                  </button>
                                </>
                              ) : (
                                <p>{list.quantity}</p>
                              )}
                            </td>
                            <td
                              className={`py-2 text-center text-xs font-medium text-[#111537] border-collapse  -0 border-y-0 w-[130px] px-2 border-slate-300`}
                            >
                              <div className="  ">
                                <Select
                                  value={list.leadTime}
                                  options={isEditing ? leadTime : []}
                                  className="w-full text-xs"
                                  menuPlacement="auto"
                                  menuPosition="fixed"
                                  menuPortalTarget={typeof document !== "undefined" ? document.body : null}
                                  styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    menu: (base) => ({ ...base, zIndex: 9999 }),
                                  }}
                                  isDisabled={!isEditing}
                                  onChange={(value) =>
                                    handleLeadTimeChange(value, index)
                                  }
                                />
                              </div>
                            </td>
                            <td
                              className={`py-2 text-center text-xs font-medium text-[#111537] border-collapse   border-y-0 w-[160px] px-2 border-slate-300`}
                            >
                              {isEditing ? (
                                <div className="text-center items-center px-1">
                                  <input
                                    type="number"
                                    className="w-[90%] py-1 text-center border rounded text-xs font-medium text-[#111537]"
                                    name="price"
                                    placeholder="0.00"
                                    value={list.price !== undefined && list.price !== null ? list.price : ""}
                                    onChange={(e) =>
                                      handlePriceChange(e, index)
                                    }
                                  />
                                </div>
                              ) : (
                                <p className="text-center w-[160px]  text-xs font-medium text-[#111537]">
                                  {Number(list?.price || 0).toLocaleString("en-US", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </p>
                              )}
                            </td>
                            <td
                              className={`py-2 text-center text-xs font-medium text-[#111537] border-collapse   border-y-0 w-[160px] px-2 border-slate-300`}
                            >
                              <div className="text-center text-xs font-medium text-[#111537]">
                                {Number(list?.convPrice || 0).toLocaleString("en-US", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </div>
                            </td>

                            <td
                              className={`py-2 text-center text-xs font-medium text-[#111537] border-collapse border-y-0 w-[150px] px-2 border-slate-300`}
                            >
                              {isEditing ? (
                                <div className="flex items-center w-[95%] mx-auto border border-gray-300 rounded bg-white overflow-hidden shadow-xs">
                                  <input
                                    type="number"
                                    min="0"
                                    step="any"
                                    className="w-full py-1 text-center text-xs font-medium text-[#111537] outline-none"
                                    placeholder="0.00"
                                    value={list.weight !== undefined && list.weight !== null ? list.weight : ""}
                                    onChange={(e) => handleWeightChange(e.target.value, index)}
                                  />
                                  <select
                                    value={list.weightUnit || list.weight_unit || "kg"}
                                    onChange={(e) => handleWeightUnitChange(e.target.value, index)}
                                    className="bg-gray-100 hover:bg-gray-200 text-[#048178] border-l border-gray-300 text-xs font-semibold py-1 px-1.5 outline-none cursor-pointer select-none"
                                  >
                                    <option value="kg">kg</option>
                                    <option value="lbs">lbs</option>
                                  </select>
                                </div>
                              ) : (
                                <p className="text-center w-[150px] text-xs font-medium text-[#111537]">
                                  {list.weight ? `${Number(list.weight).toFixed(2)} ${list.weightUnit || list.weight_unit || "kg"}` : "0.00 kg"}
                                </p>
                              )}
                            </td>

                            <td
                              className={`py-2 text-center text-xs font-medium text-[#111537] border-collapse border-y-0 w-[140px] px-2 border-slate-300`}
                            >
                              <div className="text-center text-xs font-medium text-[#111537]">
                                {Number(list.amount || 0).toLocaleString("en-US", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </div>
                            </td>

                            <td
                              className={`py-2 text-center text-xs font-medium text-[#111537] border-collapse border-y-0 w-[140px] px-2 border-slate-300`}
                            >
                              {isEditing ? (
                                <input
                                  type="number"
                                  min="0"
                                  step="any"
                                  className="w-[90%] py-1 text-center border rounded text-xs font-medium text-[#111537]"
                                  placeholder="0.00"
                                  value={list.freightCharge !== undefined && list.freightCharge !== null ? list.freightCharge : (list.freight !== undefined && list.freight !== null ? list.freight : (list.trans || ""))}
                                  onChange={(e) => handleFreightChange(e.target.value, index)}
                                />
                              ) : (
                                <p className="text-center w-[140px] text-xs font-medium text-[#111537]">
                                  {Number(list.freightCharge || list.freight || list.trans || 0).toLocaleString("en-US", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </p>
                              )}
                            </td>

                            <td
                              className={`py-2 text-center text-xs font-medium text-[#111537] border-collapse border-y-0 w-[160px] px-2 border-slate-300`}
                            >
                              <div className="text-center text-xs font-medium text-[#111537]">
                                {Number(list.totalWithFreight !== undefined && list.totalWithFreight !== null ? list.totalWithFreight : (Number(list.amount || 0) + Number(list.freightCharge || list.freight || list.trans || 0))).toLocaleString("en-US", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </div>
                            </td>

                            <td
                              className={`py-2 text-center text-xs font-medium text-[#111537] border-collapse border-y-0 w-[180px] px-2 border-slate-300`}
                            >
                              {isEditing ? (
                                <div className="flex flex-col items-center justify-center">
                                  <div className="flex items-center w-[95%] border border-gray-300 rounded bg-white overflow-hidden shadow-xs">
                                    <input
                                      type="number"
                                      min="0"
                                      step="any"
                                      className="w-full py-1 text-center text-xs font-medium text-[#111537] outline-none"
                                      placeholder={list.dutyType === "cost" ? "0.00" : "0"}
                                      value={list.duty !== undefined && list.duty !== null ? list.duty : (list.dutyValue !== undefined ? list.dutyValue : (list.dutty || ""))}
                                      onChange={(e) => handleDutyValueChange(e.target.value, index)}
                                    />
                                    <button
                                      type="button"
                                      title={`Switch to ${list.dutyType === "cost" ? "Percentage (%)" : "Cost"}`}
                                      onClick={() => handleDutyTypeToggle(index)}
                                      className="px-2 py-1 text-[10px] font-bold bg-gray-100 hover:bg-gray-200 text-[#048178] border-l border-gray-300 cursor-pointer select-none"
                                    >
                                      {list.dutyType === "cost" ? "Cost" : "%"}
                                    </button>
                                  </div>
                                  <p className="text-[9px] text-gray-500 mt-0.5">
                                    {list.dutyType === "cost" ? (
                                      <>({list.totalWithFreight > 0 ? ((Number(list.dutyAmount || 0) / list.totalWithFreight) * 100).toFixed(1) : "0.0"}%)</>
                                    ) : (
                                      <>Amt: <span className="text-red-900 font-medium">{Number(list.dutyAmount || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span></>
                                    )}
                                  </p>
                                </div>
                              ) : (
                                <div className="text-center text-xs font-medium text-[#111537]">
                                  <p>
                                    {list.dutyType === "cost" ? `Cost: ${Number(list.dutyAmount || 0).toFixed(2)}` : `${list.duty ?? list.dutyValue ?? list.dutty ?? 0}%`}
                                  </p>
                                  <p className="text-[9px] text-gray-500">
                                    Amt: <span className="text-red-900">{Number(list.dutyAmount || 0).toFixed(2)}</span>
                                  </p>
                                </div>
                              )}
                            </td>

                            <td
                              className={`py-2 text-center text-xs font-medium text-[#111537] border-collapse border-y-0 w-[180px] px-2 border-slate-300`}
                            >
                              {isEditing ? (
                                <div className="flex flex-col items-center justify-center">
                                  <div className="flex items-center w-[95%] border border-gray-300 rounded bg-white overflow-hidden shadow-xs">
                                    <input
                                      type="number"
                                      min="0"
                                      step="any"
                                      className="w-full py-1 text-center text-xs font-medium text-[#111537] outline-none"
                                      placeholder={list.localChargeType === "percent" ? "0" : "0.00"}
                                      value={list.localCharge !== undefined && list.localCharge !== null ? list.localCharge : (list.localChargeValue !== undefined ? list.localChargeValue : "")}
                                      onChange={(e) => handleLocalChargeValueChange(e.target.value, index)}
                                    />
                                    <button
                                      type="button"
                                      title={`Switch to ${list.localChargeType === "percent" ? "Cost" : "Percentage (%)"}`}
                                      onClick={() => handleLocalChargeTypeToggle(index)}
                                      className="px-2 py-1 text-[10px] font-bold bg-gray-100 hover:bg-gray-200 text-[#048178] border-l border-gray-300 cursor-pointer select-none"
                                    >
                                      {list.localChargeType === "percent" ? "%" : "Cost"}
                                    </button>
                                  </div>
                                  <p className="text-[9px] text-gray-500 mt-0.5">
                                    {list.localChargeType === "percent" ? (
                                      <>Amt: <span className="text-red-900 font-medium">{Number(list.localChargeAmount || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span></>
                                    ) : (
                                      <>({list.totalWithFreight > 0 ? ((Number(list.localChargeAmount || 0) / list.totalWithFreight) * 100).toFixed(1) : "0.0"}%)</>
                                    )}
                                  </p>
                                </div>
                              ) : (
                                <div className="text-center text-xs font-medium text-[#111537]">
                                  <p>
                                    {list.localChargeType === "percent" ? `${list.localCharge ?? list.localChargeValue ?? 0}%` : `Cost: ${Number(list.localChargeAmount || 0).toFixed(2)}`}
                                  </p>
                                  <p className="text-[9px] text-gray-500">
                                    Amt: <span className="text-red-900">{Number(list.localChargeAmount || 0).toFixed(2)}</span>
                                  </p>
                                </div>
                              )}
                            </td>

                            <td
                              className={`py-2 text-center text-xs font-medium text-[#111537] border-collapse   border-y-0 w-[150px] px-2 border-slate-300`}
                            >
                              <div className="font-semibold text-[#111537]">
                                {Number(list.finalUnitPrice !== undefined && list.finalUnitPrice !== null ? list.finalUnitPrice : (Number(list.convPrice || 0) + Number(list.landedCost || 0))).toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </div>
                            </td>
                            <td
                              className={`py-2 text-center text-xs font-medium text-[#111537] border-collapse   border-y-0 w-[150px] px-2 border-slate-300`}
                            >
                              <div className="font-semibold text-[#111537]">
                                {Number(list.total || list.rowTotal || 0).toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </div>
                            </td>
                            <td
                              className={`py-2 text-center text-xs font-medium text-[#111537] w-[70px] px-2 border-slate-300`}
                            >
                              <button
                                onClick={() =>
                                  isEditing ? handleDeleteItem(index) : {}
                                }
                                type="button"
                                className={`text-red-500 ${isEditing
                                  ? "cursor-pointer"
                                  : "cursor-default"
                                  } bg-white ml-4 border-none`}
                              >
                                <Delete color="red" height={4} />
                              </button>
                            </td>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                ) : (
                  <p></p>
                )}
              </table>
            </div>

            <div className="w-full my-6 flex justify-end items-center gap-4">
              <TextMediumBase content={"Total Price : "} />
              <p className="text-sm"> {currencySymbol} </p>
              <p className="w-64 h-8 border rounded-md text-xs pl-2 py-2">
                <NuAmount
                  defaultCurrency={false}
                  value={Number(formik?.values?.totalPrice || 0)}
                />
              </p>
            </div>
            <div className="w-full mx-auto my-4 mt-8 ">
              <div className="flex justify-end gap-4">
                <CancelButton
                  handleClick={() => {
                    Oncancel(-1);
                  }}
                />
                <SubmitButton isLoading={isLoading} />
              </div>
            </div>
          </div>
        </div>
      </form>
      {showPopup && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in w-[60%] max-h-[80vh] bg-white py-2 px-4 rounded-md shadow-lg overflow-y-scroll ">
            <h2 className="text-lg font-medium text-[14px]">Add Product</h2>
            <form onSubmit={handlePopupSubmit}>
              <div className="mb-4 flex flex-wrap">
                <NuInput
                  label="Product Name"
                  type="text"
                  formik={formik}
                  placeholder="Product Name"
                  name="productName"
                  width="w-full"
                  isRequired={true}
                />

                <DropDownAddMetaData
                  label="Unit"
                  placeholder="Choose"
                  Options={Unit}
                  formik={formik}
                  name="unit"
                  width="w-full md:w-1/2 lg:w-1/2"
                  getFunc={refUnit}
                  displayProperty={"Add Unit"}
                  propertyName={"Unit_item"}
                  isRequired={true}
                  FixPosition={true}
                />
                <DropDownAdd
                  type="text"
                  label="Category"
                  placeholder="Category"
                  Options={itemsCategory}
                  formik={formik}
                  name="category"
                  width="w-full md:w-1/2 lg:w-1/2"
                  getFunc={getCategory}
                  categoryName={"ItemCategory"}
                  displayProperty={"Add Category"}
                  isRequired={true}
                  FixPosition={true}
                />
                <DropDownAddSubCategory
                  type="text"
                  label="Sub-Category"
                  placeholder="Sub-Category"
                  Options={itemsSubCategory}
                  formik={formik}
                  name="subCategory"
                  width="w-full md:w-1/2 lg:w-1/2"
                  getFunc={fetchSubCategory}
                  category={formik?.values?.category}
                  module={"ItemCategory"}
                  displayProperty={"Add Sub-Category"}
                  FixPosition={true}
                />
              </div>
              <div className="flex justify-end">
                <button
                  type="button"
                  onClick={togglePopup}
                  className="px-5 py-[9px] cursor-pointer text-xs 2xl:text-sm bg-[#E6F2F2]  hover:bg-gray-300
                  rounded-md flex items-center mr-2 text-textColor-main"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="bg-[#048178] px-5 py-[9px] cursor-pointer outline-none border-none text-white rounded-md text-xs 2xl:text-sm flex items-center"
                >
                  Add
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {isPopupVisible && (
        <form onSubmit={formik.handleSubmit}>
          <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
            <div className="animate-scale-in w-[35%] max-h-[70vh] bg-white py-4 px-4 rounded-md shadow-lg overflow-y-scroll">
              <h2 className="text-lg font-medium text-[14px]">Duty</h2>

              {/* Landing Cost Input */}
              <div className="my-4 flex w-full gap-4">
                <label className="mt-4 text-sm font-medium text-gray-700 w-[30%]">
                  Landing Cost
                </label>
                <p className="mt-3">:</p>
                <input
                  type="text"
                  name="lCost"
                  value={formik.values.lCost}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className="text-xs 2xl:text-sm font-medium border border-gray-300 w-[60%] h-10 px-3 mt-2 rounded-[10px] outline-none"
                />
              </div>

              {/* Other Details Input */}
              <div className="my-4 flex w-full gap-4">
                <label className="w-[30%] mt-4 text-sm font-medium text-gray-700">
                  Other Details
                </label>
                <p className="mt-3">:</p>
                <input
                  type="text"
                  name="others"
                  value={formik.values.others}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className="text-xs 2xl:text-sm font-medium border border-gray-300 w-[60%] h-10 px-3 mt-2 rounded-[10px] outline-none"
                />
              </div>

              {/* Total (Read-Only) */}
              <div className="my-4 flex w-full gap-4">
                <label className="w-[30%] mt-4 text-sm font-medium text-gray-700">
                  Total
                </label>
                <p className="mt-3">:</p>
                <input
                  type="text"
                  name="boxTotal"
                  value={formik.values.boxTotal}
                  disabled
                  className="text-xs 2xl:text-sm font-medium border border-gray-300 w-[60%] h-10 px-3 mt-2 rounded-[10px] outline-none bg-gray-100"
                />
              </div>

              {/* Buttons */}
              <div className="flex justify-end gap-2">
                {/*<button
                type="button"
                onClick={popupCalculate}
                className="px-5 py-[9px] cursor-pointer text-xs 2xl:text-sm bg-[#E6F2F2] hover:bg-gray-300 rounded-md flex items-center mr-2 text-textColor-main"
              >
                Cancel
              </button> */}
                <button
                  type="button"
                  onClick={popupCalculate}
                  className="bg-[#048178] px-5 py-[9px] cursor-pointer outline-none border-none text-white rounded-md text-xs 2xl:text-sm flex items-center"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </form>
      )}
    </div>
  );
}

export default RfqCreateSupplierQuotes;
